<template>
  <v-card v-if="loading" class="pa-16" style="height: 100vh">
    <h2 class="text-center">
      <v-progress-circular
          class="mr-2"
          color="primary"
          indeterminate
      ></v-progress-circular
      >
      Loading...
    </h2>
  </v-card>
  <v-card v-else class="pa-2" style="min-height: 100vh">
    <v-card>
      <v-layout align-self-center class="p-3" row wrap>
        <v-flex class="p-2" xs3>
          <v-autocomplete
              v-model="universityValue"
              :clearable="clearable"
              :items="UNIVERSITIES"
              :loading="universityLoading"
              item-text="name"
              item-value="id"
              label="Higher Learning Institution"
              return-object
          ></v-autocomplete>
        </v-flex>
        <v-flex class="p-2" xs3>
          <v-autocomplete
              v-model="educLevelValue"
              :clearable="clearable"
              :items="EDUCATION_LEVEL"
              :loading="educLevelLoading"
              item-text="name"
              item-value="name"
              label="Education Level"
          ></v-autocomplete>
        </v-flex>
        <v-flex class="p-2" xs3>
          <v-autocomplete
              v-model="programValue"
              :clearable="clearable"
              :items="EDUCATIONAL_PROGRAMS"
              :loading="educationalProgramLoading"
              item-text="name"
              item-value="id"
              label="Educational Program"
              return-object
          ></v-autocomplete>
        </v-flex>
        <v-flex class="p-2" xs3>
          <v-autocomplete
              v-model="yearOfEducValue"
              :clearable="clearable"
              :items="YEAR_OF_EDUCATION"
              :loading="yearOfEducationLoading"
              item-text="name"
              item-value="id"
              label="Year of Education"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-row class="p-2">
        <v-col cols="3">
          <v-card elevation="2" outlined shaped>
            <v-card-title>
              <div class="iCountUp">
                <ICountUp
                    :delay="delay"
                    :endVal="preServiceSummary?.GenericEntry"
                    :options="options"
                    :startVal="count"
                />
              </div>
            </v-card-title>
            <v-card-subtitle>
              <b>No. of Generic Entry</b>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card elevation="2" outlined shaped>
            <v-card-title>
              <div class="iCountUp">
                <ICountUp
                    :delay="delay"
                    :endVal="preServiceSummary?.PostBasic"
                    :options="options"
                    :startVal="count"
                />
              </div>
            </v-card-title>
            <v-card-subtitle>
              <b>No. of Post Basic</b>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card elevation="2" outlined shaped>
            <v-card-title>
              <div class="iCountUp">
                <ICountUp
                    :delay="delay"
                    :endVal="preServiceSummary?.PostGraduate"
                    :options="options"
                    :startVal="count"
                />
              </div>
            </v-card-title>
            <v-card-subtitle>
              <b>No. of Post Graduate</b>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card elevation="2" outlined shaped>
            <v-card-title>
              <div class="iCountUp">
                <ICountUp
                    :delay="delay"
                    :endVal="preServiceSummary?.NimeiProgram"
                    :options="options"
                    :startVal="count"
                />
              </div>
            </v-card-title>
            <v-card-subtitle>
              <b>No. of Nimei Program</b>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="p-2">
        <v-col cols="6">
          <v-card>
            <v-card-subtitle>
              <b>Student By Disciplines</b>
            </v-card-subtitle>
            <apexchart :options="discipline_Options" :series="STUDENT_DISCIPLINES" height="100%" type="donut"
                       width="500"></apexchart>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-subtitle>
              <b>Student By Education Programs</b>
            </v-card-subtitle>
            <apexchart :options="education_program_Options" :series="EDUCATION_PROGRAMS" height="100%" type="donut"
                       width="500"></apexchart>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
        :headers="headers"
        :items="preServiceProfession"
        :loading="loading"
        loading-text="Loading... please wait">
    </v-data-table>
  </v-card>
</template>

<script>
import {PreserviceService} from "./preservice.service";
import ICountUp from "vue-countup-v2";
import {getEducationalPrograms, getStudentStatuses, getUniversities} from "../../utils/helper";
import {EducLevelEnum, YearOfEducEnum} from "@/utils/enums";

export default {
  name: "VueChart",
  components: {
    ICountUp,
  },
  data() {
    return {
      count: 0,
      delay: 500,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: "",
      },
      preServiceSummary: {},
      preServiceProfession: [],
      preServiceEducationProgram: [],
      headers: [
        {text: "Profession Type", value: "profession"},
        {text: "Number Student", value: "count"},
      ],
      loading: false,

      STUDENT_DISCIPLINES: [],
      EDUCATION_PROGRAMS: [],

      discipline_Options: {
        pie: {
          donut: {
            size: '65%',
          }
        },
        labels: []
      },
      education_program_Options: {
        pie: {
          donut: {
            size: '65%',
          }
        },
        labels: []
      },

      EDUCATIONAL_PROGRAMS: [],
      UNIVERSITIES: [],
      YEAR_OF_EDUCATION: [],
      EDUCATIONAL_STATUS: [],
      EDUCATION_LEVEL: [],

      universityLoading: false,
      yearOfEducationLoading: false,
      educationalProgramLoading: false,
      educStatusLoading: false,
      educLevelLoading: false,
      clearable: true,

      programValue: null,
      universityValue: null,
      yearOfEducValue: null,
      educLevelValue: null,
      currentYear: new Date().getFullYear(),
    };
  },
  watch: {
    universityValue: {
      handler: function () {
        this.fetchPreServiceSummary();
      },
    },
    educLevelValue: {
      handler: function () {
        this.fetchPreServiceSummary();
      },
    },
    programValue: {
      handler: function () {
        this.fetchPreServiceSummary();
      },
    },
    yearOfEducValue: {
      handler: function () {
        this.fetchPreServiceSummary();
      },
    },
  },
  async created() {
    await this.fetchPreServiceSummary();
    await this.initateLookups();
  },
  methods: {
    async fetchPreServiceSummary() {
      this.loading = true;
      let searchParams = '';

      this.educLevelValue !== null && (searchParams += 'preServiceLevel=' + this.educLevelValue.replace(/\s/g, '') + '&');
      this.universityValue !== null && (searchParams += 'universityId=' + this.universityValue.id + '&');
      this.programValue !== null && (searchParams += 'educationProgramId=' + this.programValue.id + '&');
      this.yearOfEducValue !== null && (searchParams += 'entryYear=' + (this.currentYear - this.yearOfEducValue) ?? this.currentYear);

      const preServiceSumResp = await PreserviceService.getPostServices(searchParams);
      let data = preServiceSumResp?.data?.rows;
      this.preServiceSummary = {};
      this.preServiceProfession = [];
      this.preServiceEducationProgram = [];

      data.forEach(item => {
        const preServiceLevel = item.preServiceLevel;
        const profession = item?.discipline?.name ?? item?.department;
        const educationProgram = item?.educationProgram?.name;
        const existingProfession = this.preServiceProfession.find(prof => prof.profession === profession);
        const existingEducationProgram = this.preServiceEducationProgram.find(prof => prof.educationProgram === educationProgram);

        this.preServiceSummary[preServiceLevel] = this.preServiceSummary[preServiceLevel] ? this.preServiceSummary[preServiceLevel] + 1 : 1;
        if (existingProfession) {
          existingProfession.count++;
        } else {
          this.preServiceProfession.push({profession, count: 1});
        }
        if (existingEducationProgram) {
          existingEducationProgram.count++;
        } else {
          this.preServiceEducationProgram.push({educationProgram, count: 1});
        }
      });

      this.STUDENT_DISCIPLINES = this.preServiceProfession?.map((data) => +data?.count);
      this.discipline_Options.labels = this.preServiceProfession?.map((data) => data?.profession);

      this.EDUCATION_PROGRAMS = this.preServiceEducationProgram?.map((data) => +data?.count);
      this.education_program_Options.labels = this.preServiceEducationProgram?.map((data) => data?.educationProgram);
      this.loading = false;
    },
    async initateLookups() {
      this.universityLoading = true;
      const univResp = await getUniversities();
      this.UNIVERSITIES = (univResp.rows && univResp.rows.length > 0) ? univResp.rows.filter((data) => {
        return data.isActive === true;
      }) : null;
      this.universityLoading = false;

      this.educationalProgramLoading = true;
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms()
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows
      this.educationalProgramLoading = false;

      this.yearOfEducationLoading = true;
      this.YEAR_OF_EDUCATION = await YearOfEducEnum.map(x => (x.name == '1st Year 1st Semester' ||
          x.name == '1st Year 2nd Semester') ? x.name = '1st Year' : x);
      this.yearOfEducationLoading = false;

      this.educLevelLoading = true;
      this.EDUCATION_LEVEL = await EducLevelEnum;
      this.educLevelLoading = false;

      this.educStatusLoading = true;
      this.EDUCATIONAL_STATUS = await getStudentStatuses();
      this.educStatusLoading = false;
    }
  },
};
</script>

<style scoped>
.iCountUp {
  font-size: 1em;
  margin: 0;
  color: #1976d2;
}
</style>
